//import * as React from "react"
import "./src/styles/global.css"
import { SafeInitializeAmplitude, SafeInitializeClarity } from "./src/components/analytics";
//const Layout = require("./src/components/layout")

export const onClientEntry = () => {
    SafeInitializeAmplitude();
    SafeInitializeClarity();
};

// // Logs when the client route changes
// exports.onRouteUpdate = ({ location, prevLocation }) => {
//   console.log("new pathname", location.pathname)
//   console.log("old pathname", prevLocation ? prevLocation.pathname : null)
// }

// // Wraps every page in a component
// exports.wrapPageElement = ({ element, props }) => {
//   return <Layout {...props}>{element}</Layout>
// }